import { render, staticRenderFns } from "./cvForm.vue?vue&type=template&id=3573906a&scoped=true"
import script from "./cvForm.vue?vue&type=script&lang=js"
export * from "./cvForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573906a",
  null
  
)

export default component.exports